$(function() {
	$('.spinner').each(function() {
		var el  = $(this);
		var add = $('.spinner-add');
		var sub = $('.spinner-sub');

		// substract
		el.parent().on('click', '.spinner-sub', function() {
			if (el.val() > 0) {
				el.val(function(i, oldval) {
					return --oldval;
				});
			}
			// disabled
			if (el.val() <= 0) {
				el.prev(sub).addClass('disabled');
			}
		});

		// increment
		el.parent().on('click', '.spinner-add', function() {
			el.val(function(i, oldval) {
				return ++oldval;
			});
			// disabled
			if (el.val() > 0) {
				el.prev(sub).removeClass('disabled');
			}
		});
	});
});